// Lib
import React, { ReactElement, ReactNode } from 'react';

// Components
import { DebugContext } from './DebugTool';

// Styles
import './debugPopup/DebugPopup.scss';

interface DebugPanelProps {
    toolName: string;
    children: ReactNode;
}

const DebugPanel = ({ toolName, children }: DebugPanelProps): ReactElement => {
    const setForcedRender = React.useState(0)[1];

    const forceRender = () => setForcedRender(Date.now());

    const contextValue = {
        toolName,
        forceRender,
    };

    return (
        <DebugContext.Provider value={contextValue}>
            <div className="DebugPanel">{children}</div>
        </DebugContext.Provider>
    );
};

export default DebugPanel;
